import { useEffect, useState } from "react";
import { _get } from "../../../libraries/fetch";
import { copyToClipboard, showToast } from "../../../libraries/clipboardUtils";
import { getPackageURL } from '../../../libraries/apiUrl';

function Packages({companyId, branchId }) {
    const [value, setValue] = useState([]);
    const [loading, setLoading] = useState(true);
    const [copiedPackageId, setCopiedPackageId] = useState(null);
    const [activeView, setActiveView] = useState('active');

    useEffect(() => {
      if (!branchId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      _get(getPackageURL(companyId, branchId), { useCache: false })
        .then(data => {
          setLoading(false);
          if (!data) {
            setValue([]);
            return;
          }

          // Handle different response structures
          let packagesList = [];
          if (Array.isArray(data)) {
            packagesList = data;
          } else if (data.response && Array.isArray(data.response)) {
            packagesList = data.response;
          } else if (data.data && Array.isArray(data.data)) {
            packagesList = data.data;
          } else if (data.packages && Array.isArray(data.packages)) {
            packagesList = data.packages;
          }

          setValue(packagesList);
        })
        .catch(() => {
          setLoading(false);
          setValue([]);
        });
    }, [branchId]);

    async function handleCopyPackageInfo(pkg, index) {
      let selectedZones = [];
      if (pkg.zones) {
        selectedZones = pkg.zones.filter(z => z.IsSelect === 1);
      }
      const packageInfo = `Package Name : ${pkg.packageName || "N/A"}\nPackage Fee : ${pkg.packageFee || "N/A"}\nRegistration Fee : ${pkg.registerationFee || "N/A"}\nNo. Of Members : ${pkg.noOfMembers || "N/A"}\nNo. Of Months : ${pkg.noOfMonths || "N/A"}\nStatus : ${pkg.isDelete ? "Inactive" : "Active"}\nZone Access : ${selectedZones.length > 0 ? selectedZones.length : "No Zone Selected"}`;
      const result = await copyToClipboard(packageInfo, { label: "Package info" });
      if (result.success) {
        showToast('Package info copied!', 'success');
        setCopiedPackageId(pkg._id || pkg.id || index);
        setTimeout(() => {
          setCopiedPackageId(null);
        }, 2000);
      } else {
        showToast(result.message, 'error');
      }
    }

    const getFilteredPackages = () => {
      if (!value || value.length === 0) {
        return [];
      }

      // Filter packages based on activeView
      if (activeView === 'active') {
        return value.filter(pkg => !pkg.isDelete);
      } else {
        return value.filter(pkg => pkg.isDelete);
      }
    };

    const renderPackageCards = () => {
      const filteredPackages = getFilteredPackages();

      if (filteredPackages.length === 0) {
        return <p style={{ padding: '20px', color: '#888' }}>No packages found</p>;
      }

      return (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 260px), 1fr))',
          gap: '20px',
          padding: '20px'
        }}>
          {filteredPackages.map((pkg, index) => {
            let selectedZones = [];
            if (pkg.zones) {
              selectedZones = pkg.zones.filter(z => z.IsSelect === 1);
            }

            // Check if package is active and has no zone selected
            const isActiveNoZone = !pkg.isDelete && selectedZones.length === 0;

            return (
              <div
                key={pkg._id || pkg.id || index}
                className={`user-card ${isActiveNoZone ? 'pulse-hover' : ''}`}
                onClick={() => handleCopyPackageInfo(pkg, index)}
                style={{
                  backgroundColor: '#2a2d35',
                  border: '1px solid #444',
                  borderRadius: '12px',
                  padding: '20px',
                  cursor: 'pointer',
                  transition: isActiveNoZone ? 'none' : 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  if (!isActiveNoZone) {
                    e.currentTarget.style.backgroundColor = '#33363f';
                    e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.4), 0 0 20px rgba(24, 119, 24, 0.3)';
                    e.currentTarget.style.border = '1px solid #187718';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActiveNoZone) {
                    e.currentTarget.style.backgroundColor = '#2a2d35';
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
                    e.currentTarget.style.border = '1px solid #444';
                  }
                }}
              >
                  <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                      fontSize: '18px',
                      fontWeight: 'bold',
                      color: pkg.isDelete ? '#ff8888' : '#88ff88',
                      margin: '0 0 15px 0',
                      borderBottom: '2px solid #187718',
                      paddingBottom: '8px'
                    }}>
                      {pkg.packageName || "N/A"}
                    </h3>
                  </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>Package Fee</span>
                  <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>{pkg.packageFee || "N/A"}</span>
                </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>Registration Fee</span>
                  <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>{pkg.registerationFee || "N/A"}</span>
                </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>No. Of Members</span>
                  <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>{pkg.noOfMembers || "N/A"}</span>
                </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>No. Of Months</span>
                  <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>{pkg.noOfMonths || "N/A"}</span>
                </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>Status</span>
                  <span style={{ fontSize: '16px', color: pkg.isDelete ? '#ff6b6b' : '#4ade80', fontWeight: '600' }}>
                    {pkg.isDelete ? "Inactive" : "Active"}
                  </span>
                </div>

                <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '15px', color: '#888' }}>Zone Access</span>
                  <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>
                    {selectedZones.length > 0 ? selectedZones.length + " zone(s)" : "No Zone Selected"}
                  </span>
                </div>

                {copiedPackageId === (pkg._id || pkg.id || index) && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    transform: 'scale(1)',
                    letterSpacing: '0.3px'
                  }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      width="16"
                      height="16"
                      fill="currentColor"
                      style={{ flexShrink: 0 }}
                    >
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>Details Copied!</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    };

    return (
      <div>
        <style>{`
          @keyframes slideInBounce {
            0% {
              opacity: 0;
              transform: translateX(20px) scale(0.8);
            }
            50% {
              transform: translateX(-5px) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(0) scale(1);
            }
          }
          @keyframes pulseHover {
            0%, 100% {
              transform: translateY(0) scale(1);
              background-color: #2a2d35;
              border-color: #444;
              box-shadow: 0 2px 8px rgba(0,0,0,0.3);
            }
            50% {
              transform: translateY(-6px) scale(1.02);
              background-color: #33363f;
              border-color: #ff4444;
              box-shadow: 0 12px 24px rgba(0,0,0,0.4), 0 0 20px rgba(255, 68, 68, 0.4);
            }
          }
          .pulse-hover {
            animation: pulseHover 1s ease-in-out infinite;
          }
        `}</style>
        <div className="configMain">
          <h1>Packages</h1>

          {loading ? (
            <p style={{ padding: '20px', color: '#fff' }}>Loading packages...</p>
          ) : (
            <>
              <div style={{ marginTop: '20px' }}>
                {/* Buttons to switch between Active and Inactive */}
                <div style={{
                  display: 'flex',
                  gap: '15px',
                  marginBottom: '30px'
                }}>
                  <button
                    onClick={() => setActiveView('active')}
                    style={{
                      padding: '12px 30px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      backgroundColor: activeView === 'active' ? '#187718' : '#1b1e25',
                      color: '#fff',
                      border: '1px solid #24272f',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      if (activeView !== 'active') {
                        e.target.style.backgroundColor = '#30353f';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (activeView !== 'active') {
                        e.target.style.backgroundColor = '#1b1e25';
                      }
                    }}
                  >
                    Active Packages
                  </button>
                  <button
                    onClick={() => setActiveView('inactive')}
                    style={{
                      padding: '12px 30px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      backgroundColor: activeView === 'inactive' ? '#187718' : '#1b1e25',
                      color: '#fff',
                      border: '1px solid #24272f',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      if (activeView !== 'inactive') {
                        e.target.style.backgroundColor = '#30353f';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (activeView !== 'inactive') {
                        e.target.style.backgroundColor = '#1b1e25';
                      }
                    }}
                  >
                    Inactive Packages
                  </button>
                </div>

                <h2 style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  color: '#fff',
                  paddingBottom: '10px',
                  borderBottom: '2px solid #187718'
                }}>
                  {activeView === 'active' ? 'Active' : 'Inactive'} Packages ({getFilteredPackages().length})
                </h2>
                {renderPackageCards()}
              </div>
            </>
          )}
        </div>
      </div>
    );
}

export default Packages;
